export default "__VITE_ASSET__efd80624__"